import Vue from 'vue'
import App from './App.vue'
import { createStore } from './store'
import { createRouter } from './router'
import { sync } from 'vuex-router-sync'
import titleMixin from './util/title'
import * as filters from './util/filters'
import english from './languages/english.js'
import indonesia from './languages/indonesia.js'

// Bootstrap import
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)

import * as VueGoogleMaps from '../node_modules/vue2-google-maps'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

// // Dependency Injection
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyB-QIXvGsDOsPtIwCB67pKi1491Tsv7wG8',
		libraries: 'places'
	}
});

// add moment
import VueMoment from 'vue-moment'
Vue.use(VueMoment)

// mixin for handling title
Vue.mixin(titleMixin)

// add vue date time
import { Datetime } from 'vue-datetime'
Vue.component('datetime', Datetime)
// Vue.use(Datetime)

// add language support
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
const messages = {
	en: english,
	id: indonesia
}
const i18n = new VueI18n({
	locale: 'en', // set locale
	messages
})

// register global utility filters.
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "UA-128171271-7" }
});
// Expose a factory function that creates a fresh set of store, router,
// app instances on each call (which is called for each SSR request)
export function createApp () {
	// create store and router instances
	const store = createStore()
	const router = createRouter()
	// sync the router with the vuex store.
	// this registers `store.state.route`
	sync(store, router)

	// create the app instance.
	// here we inject the router, store and ssr context to all child components,
	// making them available everywhere as `this.$router` and `this.$store`.
	const app = new Vue({
		router,
		store,
		i18n,
		render: h => h(App)
	})
	router.onReady(onReady=>{
		// app.$mount('#app');
		if (onReady.query&&onReady.query.lang){
			i18n.locale = onReady.query.lang;
			var _lang = 1;
			if (i18n.locale=='id'){
				_lang = 2;
			}
			if (process.__API__){

			} else {			
				store.dispatch('SETLANGUAGE',{language:_lang})
					.then(s=>{
						// console.log('Set language success : ', s)
					})
					.catch(e=>{
						// console.log('Error setting languange : ', e)
					})
			}
		}
		// console.log(onReady.query.lang);
	})
	// expose the app, the router and the store.
	// note we are not mounting the app here, since bootstrapping will be
	// different depending on whether we are in a browser or on the server.
	return { app, router, store }
}



// WEBPACK FOOTER //
// src/app.js